import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=0729133a"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/bonuses/welcome.vue
// module id = ZHMN
// module chunks = 0